<template>
  <div class="container">
    <!-- Carrossel do topo -->
    <!-- <Carousel :slides="slidesfiltered"></Carousel> -->
    <section v-if="!gtxisLogged">
      <div class="main d-flex justify-content-center">
        <b-img :src="logo" fluid class="logo"></b-img>
      </div>
      <br />
      <br />
      <h1 class="bemvindo">{{ $t("Bem vindo") }} !!!</h1>
      <br />
      <h3
        class="main-details"
        style="text-align: justify; color: #595959; background-color: white"
      >
        {{
          $t(
            "Explore funcionalidades projetadas para otimizar a gestão e execução de suas atividades através do nosso Portal de Soluções"
          )
        }}.
      </h3>
      <span class="d-flex justify-content-center">
        <b-button class="shadow" size="lg" to="/login" variant="danger">{{
          $t("Entrar")
        }}</b-button>
      </span>
    </section>
    <section v-else>
      <b-row>
        <b-col>
          <MenuCard></MenuCard>
        </b-col>
      </b-row>
    </section>

    <!-- barra de rodapé -->
    <!-- <Footer></Footer> -->
    <!-- {{ slidesfiltered }} -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Carousel from "../components/Carousel.vue";
import Footer from "./Footer.vue";
import MenuCard from "../components/MenuCard.vue";

export default {
  name: "Home",
  components: {
    Footer,
    Carousel,
    MenuCard,
  },
  data() {
    return {
      logo: require("@/assets/Vista_Aerea.jpg"),
      deal: require("@/assets/img/undraw_Interview_re_e5jn.png"),
      slides: [
        {
          src: require("@/assets/Vista_Aerea.jpg"),
          url: "https://www.kappesberg.com.br",
          roles: ["FRANQUIASROLE"],
          rolesdeny: [],
          restrict: false,
        },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/Kappesberg.jpg",
        //   url: "https://www.kappesberg.com.br",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/UZ2.jpg",
        //   url: "https://www.uzutilidades.com.br",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/Idelli.jpg",
        //   url: "https://idelli.com.br",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/MyHome.jpg",
        //   url: "https://myhomestore.com.br",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/CasaPoesia.jpg",
        //   url: "",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/Bartzen.jpg",
        //   url: "https://bartzen.com.br/",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
        // {
        //   src: require("@/assets/img/PaginaInicialPedidos.png"),
        //   url: "",
        //   roles: ["BARTZENROLE"],
        //   rolesdeny: [],
        //   restrict: true,
        // },
        // {
        //   src: require("@/assets/img/PaginaInicialTransportadoras.png"),
        //   url: "",
        //   roles: ["TRANSPORTADORASROLE"],
        //   rolesdeny: ["BARTZENROLE"],
        //   restrict: true,
        // },
        // {
        //   src: "https://www.grupok1.com.br/Assets/img/SiamoCasa.jpg",
        //   url: "https://materiais.compras.grupok1.com.br/siamo-casa",
        //   roles: ["FRANQUIASROLE"],
        //   rolesdeny: [],
        //   restrict: false,
        // },
      ],
      menus: [
        {
          title: "Home",
          icon: "house",
          route: "/",
          roles: [],
          rolesdeny: [],
        },
        // {
        //   title: "Clientes",
        //   icon: "handbag",
        //   route: "/clientesdashboard",
        //   roles: ["FRANQUIASROLE", "K1CLIENTESROLE"],
        //   rolesdeny: [],
        // },
        {
          title: "Planejados",
          icon: "rulers",
          route: "/planejadosdashboard",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Consumidores",
              icon: "people",
              route: "/planejadosconsumidores",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Consumidor",
                icon: "plus",
                route: "/planejadosconsumidoresfrm",
              },
            },
            {
              title: "Contratos",
              icon: "pen",
              route: "/planejadoscontratos",
              roles: ["FRANQUIASROLE"],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Contrato",
                icon: "plus",
                route: "/planejadoscontratosfrm",
              },
            },
            {
              title: "Orçamentos",
              icon: "wallet2",
              route: "/orcamentosbuilderlst",
              roles: ["FRANQUIASROLE", "BARTZENROLE"],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Orçamento",
                icon: "plus",
                route: "/orcamentosbuilderfrm",
              },
            },
          ],
        },
        {
          title: "Cadastros",
          icon: "inboxes",
          route: "/lancamentos",
          roles: ["BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Consumidor",
              icon: "person-plus",
              route: "/planejadosconsumidoresfrm",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Contrato",
              icon: "pen",
              route: "/planejadoscontratosfrm",
              roles: ["FRANQUIASROLE"],
              rolesdeny: [],
            },
            {
              title: "Orçamento",
              icon: "wallet2",
              route: "/orcamentosbuilderfrm",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Logística",
          icon: "truck",
          route: "/logistica",
          roles: ["TRANSPORTADORASROLE", "BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Romaneios",
              icon: "ui-checks",
              route: "/Romaneios",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Conferências de Notas",
              icon: "printer",
              route: "/notasfiscais?coletar=true",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Financeiro",
          icon: "currency-dollar",
          roles: ["BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Notas Fiscais",
              icon: "printer",
              route: "/notasfiscais",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Pedidos",
              icon: "cash-coin",
              route: "/clientespedidos",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Dashboard Pedidos",
                icon: "columns-gap",
                route: "/clientesdashboardstatus",
              },
            },
            {
              title: "Depósitos",
              icon: "bank2",
              route: "/depositos",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Dashboard Depósitos",
                icon: "columns-gap",
                route: "/depositosdashboard",
              },
            },
          ],
        },
        {
          title: "Colaboradores",
          icon: "person-badge",
          route: "/despesas",
          roles: ["K1ERPROLE"],
          rolesdeny: [],
        },
        {
          title: "Produção",
          icon: "tools",
          route: "/producao",
          roles: ["K1ERPROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Lotes",
              icon: "box-seam",
              route: "/lotes",
              roles: ["K1ERPROLE"],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Consultas",
          icon: "search",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Metas",
              icon: "pie-chart", //bar-chart-line
              route: "/metaslojistas",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Fornecedores",
          icon: "box-seam",
          route: "/fornecedores",
          roles: ["FORNECFORMULARIOSAVALIACAOROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Dashboard",
              icon: "columns-gap",
              route: "/fornecedores",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Pré-Cadastro",
              icon: "box-seam",
              route: "/comprasfornecprecadastro",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["gtxisLogged"]),
    ...mapGetters("profilerStore", ["gtxProfilerRoles"]),
    slidesfiltered() {
      return this.slides.filter((s) => this.filtrorole(s));
    },
  },
  methods: {
    scrollMeTo(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView({ behavior: "smooth" });
    },
    filtrorole(m) {
      return this.gtxProfilerRoles.length > 0
        ? m.roles.length == 0 ||
            m.roles.some(
              (role) =>
                this.gtxProfilerRoles.some((r) => r.Role === role) &&
                !m.rolesdeny.some((role) =>
                  this.gtxProfilerRoles.some((r) => r.Role === role)
                )
            )
        : !m.restrict;
    },
    menusGet() {},
  },
};
</script>

<style scoped>
.main {
  margin-top: 20px;
}
h4 {
  font-size: 3vw;
}

ul {
  list-style: none;
  margin-left: 0;
  padding-left: 1.2em;
  text-indent: -1.2em;
}

.section {
  margin-top: 50px;
}
.section,
h1 {
  margin-bottom: 30px;
}
.section,
h3 {
  margin-bottom: 30px;
}

li:before {
  content: "✓";
  padding-right: 10px;
  display: block;
  float: left;
  width: 1.2em;
  color: green;
  font-weight: bold;
}

.font-response-20 {
  font-size: 20vw;
}

.font-response-10 {
  font-size: 10vw;
}

.imagelanging {
  padding: 200px;
}

.imglogo {
  margin-left: auto;
  margin-right: auto;
}

.bemvindo {
  font-size: 56px;
  text-align: center;
  font-weight: bold;
}

.logo {
  max-width: 800px;
  min-width: 400px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px black;
  opacity: 0;
  animation: fadeIn 2s forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@media screen and (max-width: 800px) {
  .imagelanging {
    padding: 100px;
  }
}

@media screen and (max-width: 425px) {
  .main {
    margin-top: 0;
  }
  .bemvindo {
    font-size: 36px;
  }
  .main-details {
    font-size: 18px;
  }
  h4 {
    font-size: 4vw;
  }
  .imagelanging {
    padding: 50px;
  }
}
</style>